class ClcHomeLogos extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector("[data-clc-logos-track]");
    this.wrap = this.querySelector(".clc-home-logos__track-wrap");
    if (!this.track || !this.wrap) return;

    this.sourceGroup = this.track.querySelector(".clc-home-logos__group");
    if (!this.sourceGroup) return;

    this.abortController = new AbortController();
    this.refresh = this.refresh.bind(this);

    this.refresh();

    window.addEventListener("resize", this.refresh, {
      signal: this.abortController.signal,
      passive: true,
    });

    this.track.querySelectorAll("img").forEach((img) => {
      if (img.complete) return;
      img.addEventListener("load", this.refresh, {
        signal: this.abortController.signal,
        once: true,
      });
    });

    if (typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(this.refresh);
      this.resizeObserver.observe(this.wrap);
    }
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.resizeObserver?.disconnect();
  }

  refresh() {
    if (!this.track || !this.wrap || !this.sourceGroup) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.resetToSourceOnly();
      return;
    }

    this.buildLoop();
  }

  resetToSourceOnly() {
    while (this.track.children.length > 1) {
      this.track.lastElementChild.remove();
    }
    this.style.removeProperty("--clc-home-logos-shift");
  }

  buildLoop() {
    const source = this.sourceGroup;
    const wrapWidth = this.wrap.clientWidth;
    const groupWidth = source.offsetWidth;

    if (wrapWidth <= 0 || groupWidth <= 0) return;

    // Enough copies that the track is always >= 2x the viewport.
    const needed = Math.max(2, Math.ceil((wrapWidth * 2) / groupWidth));
    let count = this.track.children.length;

    while (count > needed) {
      this.track.lastElementChild.remove();
      count -= 1;
    }

    while (count < needed) {
      this.appendClone(source);
      count += 1;
    }

    this.style.setProperty("--clc-home-logos-shift", `${groupWidth}px`);

    const baseDuration =
      parseFloat(this.dataset.logosDuration) ||
      parseFloat(getComputedStyle(this).getPropertyValue("--clc-home-logos-base-duration")) ||
      36;

    if (!this.dataset.logosBaseWidth) {
      this.dataset.logosBaseWidth = String(groupWidth);
    }

    const baseWidth = parseFloat(this.dataset.logosBaseWidth) || groupWidth;
    const duration = Math.max(10, (groupWidth / baseWidth) * baseDuration);
    this.style.setProperty("--clc-home-logos-duration", `${duration}s`);
  }

  appendClone(source) {
    const clone = source.cloneNode(true);
    clone.setAttribute("aria-hidden", "true");
    clone.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));
    this.track.appendChild(clone);
  }
}

if (!customElements.get("clc-home-logos")) {
  customElements.define("clc-home-logos", ClcHomeLogos);
}
